<template>
    <div class="codics-admin-lottery-body">
        <div class="codics-admin-lottery-control" style="margin-bottom: 20px;">
            <el-button class="codics-admin-lottery-control-search" type="success" icon="el-icon-plus"
                @click="addLotteryDialog = true;" plain>添加奖品</el-button>
            <el-select class="codics-admin-lottery-control-search" v-model="nowType" placeholder="请选择活动"
                @change="typeChange">
                <el-option v-for="item in typeOptions" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
            </el-select>
            <!-- 添加表单 -->
            <el-dialog title="添加奖品" :visible.sync="addLotteryDialog" width="80%">
                <el-form :model="addForm">
                    <el-form-item label="对应活动" :label-width="formLabelWidth">
                        <el-select v-model="addForm.cid" placeholder="请选择活动">
                            <el-option v-for="item in typeOptions1" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="奖品名称" :label-width="formLabelWidth">
                        <el-input v-model="addForm.name" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="奖品图片" :label-width="formLabelWidth">
                        <el-upload action="https://cdn.bosscaigou.com/" list-type="picture-card"
                            :on-preview="handlePictureCardPreview" class="codics-admin-lottery-upload"
                            :http-request="uploadFile" :on-remove="handleRemove"
                            :style="{ '--himgSize': addForm.img == '' ? 'inline-block' : 'none' }" ref="fmUpload">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="奖品概率" :label-width="formLabelWidth">
                        <el-input-number v-model="addForm.odds" :min="0" :max="10000000"
                            label="设置中奖概率"></el-input-number>
                    </el-form-item>
                    <el-form-item label="奖品数量" :label-width="formLabelWidth">
                        <el-input-number v-model="addForm.count" :min="0" :max="10000000"
                            label="奖品数量"></el-input-number>
                    </el-form-item>
                    <el-form-item label="奖品状态" :label-width="formLabelWidth">
                        <el-select v-model="addForm.state" placeholder="请选择">
                            <el-option label="上架" value='0'></el-option>
                            <el-option label="下架" value='1'></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="addLotteryDialog = false">取 消</el-button>
                    <el-button type="primary" @click="addLotteryFuc">确 定</el-button>
                </div>
            </el-dialog>
            <!-- 修改表单 -->
            <el-dialog title="修改奖品信息" :visible.sync="updateLotteryDialog" width="80%">
                <el-form :model="updateForm">
                    <el-form-item label="对应活动" :label-width="formLabelWidth">
                        <el-select v-model="updateForm.cid" placeholder="请选择活动">
                            <el-option v-for="item in typeOptions1" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="奖品名称" :label-width="formLabelWidth">
                        <el-input v-model="updateForm.name" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="奖品图片" :label-width="formLabelWidth">
                        <el-upload action="https://cdn.bosscaigou.com/" class="codics-admin-lottery-upload"
                            list-type="picture-card" :on-preview="handlePictureCardPreview"
                            :style="{ '--himgSize': updateForm.img == '' ? 'inline-block' : 'none' }"
                            :http-request="a => uploadFile(a, 1)" :on-remove="handleRemove" ref="fmUpload">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="奖品概率" :label-width="formLabelWidth">
                        <el-input-number v-model="updateForm.odds" :min="0" :max="10000000"
                            label="设置中奖概率"></el-input-number>
                    </el-form-item>
                    <el-form-item label="奖品数量" :label-width="formLabelWidth">
                        <el-input-number v-model="updateForm.count" :min="0" :max="10000000"
                            label="奖品数量"></el-input-number>
                    </el-form-item>
                    <el-form-item label="奖品状态" :label-width="formLabelWidth">
                        <el-select v-model="updateForm.state" placeholder="请选择">
                            <el-option label="上架" :value='0'></el-option>
                            <el-option label="下架" :value='1'></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="updateLotteryDialog = false">取 消</el-button>
                    <el-button type="primary" @click="updateLotteryFuc">确 定</el-button>
                </div>
            </el-dialog>
            <el-input class="codics-admin-lottery-control-search" style="width: 300px !important;"
                placeholder="请输入活动名称..." v-model="searchTxt" clearable @input="searchChange">
                <el-button style="padding: 0 0px 0 15px;margin-right: 0 !important;" slot="append" icon="el-icon-search"
                    @click="searchPage = 1; searchMax = 0; searchData = []; nowSearchTxt = searchTxt; getLotteryData();"></el-button>
            </el-input>
            <el-popconfirm :title="'您确定要删除当前选中的' + selectData.length + '条数据吗？'" @confirm="deleteLotteriesFuc">
                <el-button class="codics-admin-lottery-control-search iconfont" slot="reference" type="danger"
                    icon="el-icon-delete" plain>批量删除</el-button>
            </el-popconfirm>
        </div>
        <el-table stripe class="codics-admin-lottery-table" :data="searchTxt == '' ? lotteryData : searchData" border
            style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="40">
            </el-table-column>
            <el-table-column prop="id" label="ID" width="80">
            </el-table-column>
            <el-table-column prop="cid" label="活动" width="80">
            </el-table-column>
            <el-table-column prop="name" label="名称" width="180">
            </el-table-column>
            <el-table-column prop="img" label="图片" width="60">
                <template slot-scope="scope">
                    <el-image style="top:3.5px"
                        :src="scope.row.img == null ? 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png' : ('https://cdn.bosscaigou.com/' + scope.row.img)"
                        fit="fill">
                        <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                </template>
            </el-table-column>
            <el-table-column prop="odds" label="概率" width="80">
            </el-table-column>
            <el-table-column prop="count" label="剩余数量" width="80">
            </el-table-column>
            <el-table-column prop="state" label="状态" width="70"
                :filters="[{ text: '上架', value: 0 }, { text: '下架', value: 1 }]" :filter-method="stateFilter"
                filter-placement="bottom-end">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.state == 0 ? 'success' : 'danger'" disable-transitions>{{ scope.row.state
                    ==
                    0 ? '上架' : '下架' }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column align="right" label="操作" min-width="150">
                <template slot-scope="scope">
                    <el-button size="mini"
                        @click="updateForm = scope.row; updateLotteryDialog = true; handleEdit(scope.row)"
                        style="margin-right: 10px;">编辑</el-button>
                    <el-popconfirm title="您确定要删除当前数据吗？" @confirm="deleteLotteriesFuc([scope.row.id])">
                        <el-button size="mini" type="danger" slot="reference">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="codics-admin-lottery-table-page" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :current-page="searchTxt == '' ? currentPage : searchPage"
            :page-sizes="[10, 20, 30, 40]" :page-size="searchTxt == '' ? dataSize : searchSize"
            layout="total, sizes, prev, pager, next, jumper" :total="searchTxt == '' ? maxSize : searchMax">
        </el-pagination>
    </div>
</template>

<script>
import * as qiniu from 'qiniu-js';
import { listPrizes, addLottery, queryProduct, getQiNiuToken, allActives, deleteLotteries, updateLottery } from '@/api';
export default {
    data() {
        return {
            nowType: 0,
            searchTxt: '',
            addLotteryDialog: false,
            updateLotteryDialog: false,
            addForm: {
                cid: '',
                name: '',
                img: '',
                odds: 0,
                count: 0,
                state: '0'
            },
            updateForm: {
                cid: '',
                name: '',
                img: '',
                odds: 0,
                count: 0,
                state: '0'
            },
            qiNiuInfo: {
                token: ''
            },
            typeOptions: [
                {
                    id: 0,
                    name: '全部活动'
                }
            ],
            typeOptions1: [],
            formLabelWidth: '120px',
            searchBrand: '名称',
            currentPage: 1,
            searchPage: 1,
            tableData: [],
            selectData: [],
            multipleSelection: [],
            maxSize: 0,
            searchMax: 0,
            dataSize: 10,
            searchSize: 10,
            lotteryData: [],
            shopLoad: false,
            productOptions: [],
            addSelect: '',
            nowSearchTxt:''
        }
    },
    mounted() {

        this.$emit('check-mem');

        this.getLotteryData();

        this.listActivesFuc();

        this.getTokenFuc();

    },
    methods: {
        async listActivesFuc() {

            let data = await allActives();

            if (data.code == 200) {

                this.typeOptions = [...this.typeOptions, ...data.data];

                this.typeOptions1 = [...data.data];

            } else {

                this.$message.error(data.message);

            }

        },
        typeChange(a) {
            this.getLotteryData();
        },
        stateFilter(v, r, c) {

            return r.state === v;

        },
        async getTokenFuc() {
            let data = await getQiNiuToken();
            if (data.code == 200) {
                this.qiNiuInfo.token = data.uptoken;
            } else {
                this.$message.error(data.message);
            }
        },
        async getLotteryData() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await listPrizes({ id: this.nowType, key: this.nowSearchTxt, pge: this.searchTxt == '' ? this.currentPage : this.searchPage, psz: this.searchTxt == '' ? this.dataSize : this.searchSize });

            loading.close();

            if (data.code == 200) {

                if (this.nowSearchTxt == '') {

                    this.lotteryData = data.data;

                    this.maxSize = data.data1;

                } else {

                    this.searchData = data.data;

                    this.searchMax = data.data1;

                }

            } else {

                this.$message.error(data.message);

            }

        },
        handleSizeChange(val) {
            if (this.searchTxt == '') {
                this.dataSize = val;
            } else {
                this.searchSize = val;
            }
            this.getLotteryData();
        },
        handleCurrentChange(val) {
            if (this.searchTxt == '') {
                this.currentPage = val;
            } else {
                this.searchPage = val;
            }
            this.getLotteryData();
        },
        sexFilter(v, r, c) {

            return r.sex === v;

        },
        handleSubCat(value) {
            // 获取value值
            this.addForm.p = value.length == 0 ? 0 : value[value.length - 1];
            // 获取label 值
            // console.log(this.$refs["refSubCat"].getCheckedNodes()[0].label)
        },
        async queryProductData(query) {

            if (query !== '') {
                this.shopLoad = true;
                let data = await queryProduct({ key: query });
                this.shopLoad = false;
                if (data.code == 200) {

                    this.$message({
                        message: '查询商品成功！',
                        type: 'success'
                    });

                    this.productOptions = data.data;

                } else {

                    this.$message.error(data.message);

                    this.productOptions = [];

                }
            } else {
                this.productOptions = [];
            }

        },
        selectChange(key) {
            this.addForm.pid = key.id;
            this.addForm.name = key.name;
        },
        // 图片点击预览
        handlePictureCardPreview(file) {

        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        // 上传方法
        uploadFile(uploadInfo, a) {

            console.log(uploadInfo, a)

            this.addForm.img = 'huayuan/img/' + uploadInfo.file.name.replace(',', '');

            const _that = this;
            // 上传文件
            const observer = {
                next(res) {
                    // console.log('next: ', res)
                },
                error(err) {
                    // console.log(err)
                },
                complete(res) {
                    // console.log('complete: ', res)
                    console.log('11111111111111:', a)
                    if (a == null) {
                        _that.addForm.img = '/' + res.key;
                    } else {
                        _that.updateForm.img = '/' + res.key;
                    }
                }
            }
            const observable = qiniu.upload(uploadInfo.file, 'huayuan/img/' + uploadInfo.file.name, this.qiNiuInfo.token, {}, {

            })
            const subscription = observable.subscribe(observer) // 上传开始
            // console.log(subscription);
            // subscription.unsubscribe() // 上传取消
        },
        // 图片删除
        handleRemove() {
            this.addForm.img = '';
            this.updateForm.img = '';
        },
        clearSelect() {
            this.addForm.pid = '';
            this.addForm.count = 0;
        },
        async addLotteryFuc() {
            if (this.addForm.cid == null) {

                this.$message({
                    showClose: true,
                    message: '请先绑定相应的活动！',
                    type: 'warning'
                });

                return true;

            }
            if (this.addForm.name == '' || this.addForm.img == '') {

                this.$message({
                    showClose: true,
                    message: '请先选中合适的奖品并上传名称及图片！',
                    type: 'warning'
                });

                return true;

            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = await addLottery(this.addForm);
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '数据添加成功！',
                    type: 'success'
                });
                setTimeout(() => {
                    window.location.reload();
                }, 300);
            } else {
                this.$message.error(data.message);
            }
        },
        searchChange(a) {
            if (a == '') {
                this.searchPage = 1;
                this.searchData = [];
                this.searchMax = 0;
                this.searchSize = 10;
                this.nowSearchTxt = '';
            }
        },
        async deleteLotteriesFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要删除的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await deleteLotteries({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: data.data + '条数据删除成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                this.$message.error(data.message);

            }

        },
        async updateLotteryFuc() {

            if (this.updateForm.name == '') {

                this.$message.error('活动名称不能为空！');

                return;

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await updateLottery(this.updateForm);

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '更新奖品成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                this.$message.error(data.message);

            }

        },
        handleEdit(row) {
            setTimeout(() => {
                this.$refs['fmUpload'].uploadFiles = [];
                this.$refs['fmUpload'].uploadFiles.push({
                    name: '',
                    percentage: '',
                    raw: '',
                    size: '',
                    status: '',
                    uid: new Date().getTime(),
                    url: "https://cdn.bosscaigou.com/" + row.img
                })
            }, 30);
        }
    }
}
</script>

<style>
/* 后台管理端主页 */
.codics-admin-lottery-body {
    height: fit-content;
    min-height: 100%;
    width: 100%;
    position: relative;
    float: left;
    background: #FFF;
    box-sizing: border-box;
    padding: 20px;
}

/* 后台管理页面主页 */
.codics-admin-lottery-control {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
}

/* 后台管理页面主页控制栏 */
.codics-admin-lottery-control-input {
    width: 200px !important;
    position: relative;
    float: left;
    margin-right: 20px;
    margin-bottom: 20px;
}

/* 后台管理页面控制栏搜索按钮 */
.codics-admin-lottery-control-search {
    position: relative;
    float: left;
    margin-left: 0px !important;
    margin-right: 20px !important;
}

/* 表格控件 */
.codics-admin-lottery-table {
    height: fit-content;
    width: 100% !important;
    position: relative;
    float: left;
    margin-bottom: 20px;
}

/* 表格分页控件 */
.codics-admin-lottery-table-page {
    position: relative;
    float: right;
    right: 0;
}




.codics-admin-lottery-upload .el-upload {
    display: var(--himgSize);
}
</style>